import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Clock } from "lucide-react";

export default function EmpathyDetail() {
  const { id } = useParams();
  const [ex, setEx] = useState(null);

  useEffect(() => {
    api.get(`/empathy/exercises/${id}`).then(({ data }) => setEx(data)).catch(() => setEx(false));
  }, [id]);

  if (ex === null) return <div className="max-w-3xl mx-auto px-6 py-20 text-mindora-muted">Loading…</div>;
  if (ex === false) return <div className="max-w-3xl mx-auto px-6 py-20">Exercise not found.</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-0 py-20" data-testid="page-empathy-detail">
      <Link to="/empathy" className="inline-flex items-center gap-2 text-sm text-mindora-muted hover:text-mindora-red mb-8">
        <ArrowLeft size={14} /> back to toolkit
      </Link>
      <div className="text-xs uppercase tracking-[0.2em] text-mindora-red">{ex.category}</div>
      <h1 className="font-serif text-4xl lg:text-5xl text-mindora-ink leading-tight mt-3">{ex.title}</h1>
      <div className="mt-3 flex items-center gap-2 text-sm text-mindora-muted">
        <Clock size={14} /> {ex.duration_min} minutes
      </div>
      <p className="mt-6 font-serif text-xl text-mindora-ink/80 leading-relaxed">{ex.summary}</p>

      <div className="divider-vine my-10" />

      <ol className="space-y-5">
        {ex.steps.map((s, i) => (
          <li key={i} className="flex gap-5 items-start" data-testid={`empathy-step-${i}`}>
            <span className="font-serif text-3xl text-mindora-red leading-none mt-1">{i + 1}</span>
            <span className="font-serif text-lg text-mindora-ink leading-relaxed">{s}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
